module.exports = __webpack_public_path__ + "img/TZS09432.80f0eed7.jpeg";